import { render, staticRenderFns } from "./LoaderAnimation.vue?vue&type=template&id=6e8c5189&scoped=true&"
import script from "./LoaderAnimation.vue?vue&type=script&lang=js&"
export * from "./LoaderAnimation.vue?vue&type=script&lang=js&"
import style0 from "./LoaderAnimation.vue?vue&type=style&index=0&id=6e8c5189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c5189",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
